// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25t3P","field":"styles_field__IQ24c","fieldCol":"styles_fieldCol__3AZUV","diffCol":"styles_diffCol__3WwIR","diff":"styles_diff__73FHS"};